import LeftRouteStatusBadges
    from "@Route/features/statusBadges/features/leftStatusBadges/components/LeftRouteStatusBadges";
import IntermodalRouteWithDetailsType from "@Intermodal/types/IntermodalRouteWithDetails.type";
import RouteWithAddedPropsAndPricesType from "@Route/types/RouteWithAddedPropsAndPrices.type";
import SuggestedRouteType from "@Route/types/SuggestedRoute.type";
import RightRouteStatusBadges
    from "@Route/features/statusBadges/features/rightStatusBadges/components/RightRouteStatusBadges";

interface RouteStatusBadgesProps {
    route: IntermodalRouteWithDetailsType | RouteWithAddedPropsAndPricesType | SuggestedRouteType,
}

/**
 * Route status badges located on top of each route card
 */
function RouteStatusBadges({route}: RouteStatusBadgesProps) {
    return (
        <div className="route-status-badges">
            <LeftRouteStatusBadges
                route={route}
            />
            <RightRouteStatusBadges
                route={route}
            />
        </div>
    )
}

export default RouteStatusBadges